import type { Schemas } from "#shopware";
import { ref } from "vue";

const _useProductReviews = () => {
  const reviews = ref<Schemas["ProductReview"][]>([]);

  const setReviews = (newReviews: Schemas["ProductReview"][]) => {
    reviews.value = newReviews;
  };

  return {
    reviews,
    setReviews,
  };
};

export const useProductReviews = createSharedComposable(_useProductReviews);
